module.exports = __webpack_public_path__ + "img/TV.ff417167.png";